var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video)?_c('section',{class:[_vm.block.class, 'has-text-centered hero', _vm.block.mode.toLowerCase()],attrs:{"id":_vm.block.anchor ? _vm.block.anchor : ('block-' + _vm.block.id)}},[_c('div',{staticClass:"hero-body is-paddingless",domProps:{"innerHTML":_vm._s(_vm.video)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de1157a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/modules/herotypes/PageHeroVideoMode.vue
// module id = null
// module chunks = 